export default {
  serverSideInfiniteScroll: true,
  rowModelType: 'serverSide',
  cacheBlockSize: 50,
  domLayout: 'normal',
  sortingOrder: ['desc', 'asc', null],
  defaultColDef: {
    sortable: true,
    filter: 'agTextColumnFilter',
    menuTabs: ['filterMenuTab', 'generalMenuTab'],
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  animateRows: true,
  rowSelection: 'multiple',
  suppressRowClickSelection: true,
  enableRangeSelection: true,
  scrollbarWidth: 15,
  getContextMenuItems: (params) => {
    return ['copy']
  },
  sideBar: {
    // src: https://www.ag-grid.com/documentation/react/tool-panel-columns/#section-visibility
    toolPanels: [
      {
        id: 'columns',
        labelDefault: '',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivotMode: true,
        },
      },
    ],
  },
}
